import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { daiWebhooks } from '../../docs-routes'
import type { CSSProperties } from 'react'

const popupBodyStyle: CSSProperties = {
  marginBottom: '16px',
  marginTop: '5px'
}

const WebhookRequestHeadersDescription = () =>
  <>
    <Header
      hasNoTopMargin
      rank={4}
    >
      Request headers
    </Header>
    <div style={popupBodyStyle}>
      <Paragraph>
        <Color variant='greyB'>
          Enter any applicable request headers for the webhook, e.g., auth tokens or content type.
          If you have multiple request headers, specify each one on separate lines.
        </Color>
      </Paragraph>
    </div>
    <Paragraph>
      <LinkToDocusaurus path={daiWebhooks}>
        Learn more in the DAI documentation
      </LinkToDocusaurus>
    </Paragraph>
  </>

export default WebhookRequestHeadersDescription
